import { Buffer as shimBuffer } from 'buffer';

export let process = {
  NODE_ENV: 'production',
  env: {
    REACT_APP_SC_ATTR: 'data-styled-airmodules'
  }
};

export let Buffer = shimBuffer;
